import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Layout from '../../../Components/Layout'
import TicketDetails from '../../../Components/OrderMgt/TicketDetails'
import useHttpHook from '../../../Hooks/HttpHook'
import { GetTicketDetails } from '../../../utils/ApiConstant'
import { OrderLanguage } from '../../../utils/Languages'

const TicketDetailsPage = () => {
    const { ticketId, attendeeId,orderId } = useParams()
    const [loading, sendRequest, error] = useHttpHook()
    
    const [data, setData] = useState({})

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        try {
            const result = await sendRequest(`${GetTicketDetails}/${ticketId}/${attendeeId}`, {
                method: 'get',
            })
            if (result?.status === 1) {
                setData(result.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <Layout  BackAction={`/myOrder/${orderId}`} Heading={OrderLanguage.TicketDetails.heading} TitleMark={true} TitleMarkClassName="event-ticket-detail-title-mark" TitleClassName="event-ticket-detail-title" HeadClassName="event-ticket-detail-head" DetailsHead ExtraclassName="event-ticket-detail-panel" activeMenuId="orders">
            <TicketDetails isLoading={loading} isError={error} details={data} />
        </Layout>
    )
}

export default TicketDetailsPage